import React from 'react';
import { Box, Card, Stack } from '@mui/material';

import { CandidateDetailsAction } from '@constants';
import { IAvailableCandidate } from '@types';
import { listCardSx } from 'theme/surfaces';
import { AvailableCandidateActions } from './AvailableCandidateActions';
import { AvailableCandidateMaterials } from './AvailableCandidateMaterials';
import { AvailableCandidateNameCell } from './AvailableCandidateNameCell';
import { AvailableFromCell } from './AvailableFromCell';

interface IAvailableCandidateCardProps {
  candidate: IAvailableCandidate;
  onClick: () => void;
  onAction: (candidateId: string, action: CandidateDetailsAction) => void;
  onLearnMore: (candidateId: string) => void;
  onOpenResume: (candidateId: string) => void;
}

export const AvailableCandidateCard: React.FC<IAvailableCandidateCardProps> = ({
  candidate,
  onClick,
  onAction,
  onLearnMore,
  onOpenResume,
}) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={{ ...listCardSx, pt: 1, pb: 2, cursor: 'pointer' }}
  >
    <Stack gap={1}>
      <AvailableCandidateNameCell candidate={candidate} withRegion={false} />

      <AvailableFromCell candidate={candidate} />

      <Box
        display="flex"
        alignItems="center"
        gap={1}
        rowGap={1.5}
        flexWrap="wrap"
      >
        <AvailableCandidateActions
          candidate={candidate}
          variant="card"
          onAction={onAction}
          onLearnMore={onLearnMore}
        />
        {(candidate.hasVideo || candidate.hasResume) && (
          <Box ml="auto">
            <AvailableCandidateMaterials
              candidate={candidate}
              resumeLabel="Resume"
              onPlay={onClick}
              onOpenResume={onOpenResume}
            />
          </Box>
        )}
      </Box>
    </Stack>
  </Card>
);
